import { IImageColors, IImageResolution, IImageUrl } from '../../data-structures';


/**------------------------------------------------------
 * Update Pod Image Data Request API-Interfaces
 */
export interface IUpdatePodImageRequest {
	data: IUpdatePodImageRequestEntry[];
}

export interface IUpdatePodImageRequestEntry {
	flyId		: string;
	resolution	: IImageResolution;
	colors		: IImageColors;
	pHash		: string;
	imgUrl      : IImageUrl;
}
